(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfResizable', [
    '$window', '$parse', '$timeout', '$rootScope', function($window, $parse, $timeout, $rootScope) {
      return {
        restrict: 'A',
        link: {
          post: (function(_this) {
            return function(scope, element, attrs) {
              return void 0;
            };
          })(this),
          pre: (function(_this) {
            return function(scope, element, attrs) {
              var active, debounced, debug, options, resizeit, target_element, target_selector;
              active = true;
              target_selector = attrs.mfResizable;
              if ((target_selector != null) && target_selector !== '') {
                if (target_selector[0] === '{') {
                  options = $parse(target_selector)(scope);
                  target_element = element.closest(options.target);
                  active = !!options.active;
                } else {
                  target_element = element.closest(target_selector);
                }
              } else {
                target_element = element.parent();
              }
              if (!active) {
                return;
              }
              debug = false;
              resizeit = function() {
                var ref;
                return $timeout((function(_this) {
                  return function() {
                    var adjustment, available_height, child, element_padding, final_height, height_of_children, i, len, new_height, ref, target_height;
                    if (debug) {
                      console.log(element);
                    }
                    element.hide();
                    target_height = target_element.height();
                    if (debug) {
                      console.log(target_element);
                    }
                    if (debug) {
                      console.log("target_height=" + target_height);
                    }
                    height_of_children = 0;
                    ref = target_element.children();
                    for (i = 0, len = ref.length; i < len; i++) {
                      child = ref[i];
                      child = angular.element(child);
                      if (child.is(':visible') && (child.css('float') === 'none' || element.closest(child).length > 0)) {
                        height_of_children += child.outerHeight(true);
                      }
                    }
                    if (debug) {
                      console.log("height_of_children=" + height_of_children);
                    }
                    available_height = target_height - height_of_children;
                    element.show();
                    element_padding = element.outerHeight(true) - element.height();
                    if (debug) {
                      console.log("element_padding=" + element_padding);
                    }
                    new_height = available_height - element_padding;
                    if (attrs.mfResizableAdjustment != null) {
                      adjustment = parseFloat(attrs.mfResizableAdjustment);
                      final_height = new_height + adjustment;
                      element.height(new_height + adjustment);
                      if (debug) {
                        console.log("adjustment=" + adjustment);
                      }
                      if (debug) {
                        console.log("final_height=" + final_height);
                      }
                    } else {
                      if (debug) {
                        console.log("final_height=" + new_height);
                      }
                      element.height(new_height);
                    }
                    return $rootScope.$broadcast('resizable:resized');
                  };
                })(this), parseInt((ref = attrs.mfResizableDelay) != null ? ref : 0));
              };
              resizeit();
              debounced = debounce(function() {
                return resizeit();
              });
              angular.element($window).on('resize', debounced);
              return scope.$on('$destroy', function() {
                return angular.element($window).off('resize', debounced);
              });
            };
          })(this)
        }
      };
    }
  ]);

}).call(this);
